// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.5_@swc+helpers@0.5.18__webpack@5.105.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.5_@swc+helpers@0.5.18__webpack@5.105.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Box sizing */
*,
*::before,
*::after {
    box-sizing: border-box;
}

/* Remove default margin and padding */
body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
dl,
dd,
ol,
ul,
figure {
    margin: 0;
    padding: 0;
}

/* Set default font settings */
body {
    font-family: "Noto Sans", sans-serif;
    font-weight: 400;
    line-height: 1.5;
}

/* Remove list styles */
ol,
ul {
    list-style: none;
}

/* Reset heading sizes */
h1,
h2,
h3,
h4,
h5,
h6 {
    font-size: 100%;
    font-weight: normal;
}

/* Anchor styling */
a {
    text-decoration: none;
    color: inherit;
}

/* Hack to make the dropdown open upwards */
.dropdown-content-up {
    top: auto !important;
    bottom: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/ui/ThemeProvider/normalizations.css"],"names":[],"mappings":"AAAA,eAAe;AACf;;;IAGI,sBAAsB;AAC1B;;AAEA,sCAAsC;AACtC;;;;;;;;;;;;;;;IAeI,SAAS;IACT,UAAU;AACd;;AAEA,8BAA8B;AAC9B;IACI,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;;IAEI,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;;;;;;IAMI,eAAe;IACf,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA,2CAA2C;AAC3C;IACI,oBAAoB;IACpB,uBAAuB;AAC3B","sourcesContent":["/* Box sizing */\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\n/* Remove default margin and padding */\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\ndl,\ndd,\nol,\nul,\nfigure {\n    margin: 0;\n    padding: 0;\n}\n\n/* Set default font settings */\nbody {\n    font-family: \"Noto Sans\", sans-serif;\n    font-weight: 400;\n    line-height: 1.5;\n}\n\n/* Remove list styles */\nol,\nul {\n    list-style: none;\n}\n\n/* Reset heading sizes */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-size: 100%;\n    font-weight: normal;\n}\n\n/* Anchor styling */\na {\n    text-decoration: none;\n    color: inherit;\n}\n\n/* Hack to make the dropdown open upwards */\n.dropdown-content-up {\n    top: auto !important;\n    bottom: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
